export const TOUR_PRIVACY = {
    PUBLIC: 'PUBLIC',
    PRIVATE: 'PRIVATE',
    UNLISTED: 'UNLISTED',
}